"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Title = _interopRequireDefault(require("../../Title"));

var _utils = require("../../utils");

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var BuyNowComponent = function BuyNowComponent(props) {
  var _a = props || {},
      configuration = _a.configuration,
      flexTitle = _a.flexTitle;

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'children'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      margin: '0 -24px'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    title: flexTitle
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'children-content'
  }, configuration === null || configuration === void 0 ? void 0 : configuration.map(function (item, index) {
    var _a = item || {},
        title = _a.title,
        description = _a.description,
        svg = _a.svg,
        href = _a.href,
        more = _a.more,
        extendProps = _a.extendProps;

    var _b = (0, _utils.fomateFileData)(svg),
        url = _b.url,
        _c = _b.alt,
        alt = _c === void 0 ? '' : _c;

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: 'children-list',
      key: index
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'children-list-top'
    }, /*#__PURE__*/_react["default"].createElement("span", null, title), url ? /*#__PURE__*/_react["default"].createElement("img", {
      src: url,
      alt: alt
    }) : ''), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'children-list-but'
    }, /*#__PURE__*/_react["default"].createElement("div", {
      dangerouslySetInnerHTML: {
        __html: description
      }
    }), /*#__PURE__*/_react["default"].createElement("a", __assign({
      href: href
    }, extendProps || {}), more)));
  })));
};

BuyNowComponent.displayName = 'TCIBuyNowComponent';
var _default = BuyNowComponent;
exports["default"] = _default;